<template>
  <div>
    <div class="vd-gl-content">
      <a-row class="vd-toolbar">
        <a-col class="vd-toolbar-left vd-bar">
          <a-form layout="inline">
            <a-form-item>
              <a-input
                class="vd-input-xs"
                v-model="searchForm.username"
                placeholder="工号"
              />
            </a-form-item>
            <a-form-item>
              <a-input
                class="vd-input-xs"
                v-model="searchForm.nickname"
                placeholder="昵称"
              />
            </a-form-item>
            <a-form-item>
              <a-cascader
                style="width: 216px"
                :options="areaTree"
                v-model="searchForm.areaPath"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }"
                placeholder="请选择用户所属地区"
                :change-on-select="true"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 14 }">
              <a-button type="primary" icon="search" @click="search()" />
            </a-form-item>
            <a-form-item>
              <a-button-group class="vd-bar-button">
                <a-button
                  icon="tool"
                  :loading="batchQrCodeStatus"
                  @click="batchQrCode"
                >
                  批量生成二维码</a-button
                >
                <a-button icon="export" @click="batchExportQr"
                  >导出二维码</a-button
                >
              </a-button-group>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>

      <a-table
        :data-source="list"
        :pagination="pagination"
        row-key="id"
        size="small"
      >
        <a-table-column title="序号" data-index="id" />
        <a-table-column align="center" title="工号" data-index="username" />
        <a-table-column align="center" title="昵称" data-index="nickname" />
        <a-table-column align="center" title="地区" data-index="area_name" />
        <a-table-column align="center" title="二维码" data-index="qrcode">
          <template slot-scope="text">
            <a-tooltip>
              <template slot="title">
                <img :src="text" alt="二维码" style="width: 160px" />
              </template>
              <a-avatar :src="text" shape="square" :size="84">二维码 </a-avatar>
            </a-tooltip>
          </template>
        </a-table-column>

        <a-table-column align="center" title="创建时间" data-index="add_time">
          <template slot-scope="item">
            {{ $FormatUtil.timestamp2date(item, 'MM-DD HH:mm') }}
          </template>
        </a-table-column>
        <a-table-column align="center" title="操作">
          <template slot-scope="item">
            <a-tooltip title="生成二维码">
              <a-icon
                type="qrcode"
                class="common-icon"
                @click="createQr(item.id)"
              />
            </a-tooltip>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { create_qr, auto_get_member } from '@/api/auto'
import { get_area_tree } from '@/api/auth'
import XLSX from 'xlsx'
export default {
  name: 'Member',
  data() {
    return {
      id: undefined,
      batchQrCodeStatus: false,
      list: [],
      areaTree: [],
      searchForm: {
        username: undefined,
        nickname: undefined,
        areaPath: undefined,
      },
      pagination: {
        total: 1,
        current: 1,
        pageSize: 5,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  mounted() {
    this.id = parseInt(this.$route.query.id)
    this.getData()
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      } else {
        this.$message.warning(res.msg)
      }
    })
  },
  methods: {
    getData() {
      auto_get_member({
        activeId: this.id,
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        username: this.searchForm.username,
        nickname: this.searchForm.nickname,
        areaPath: this.searchForm.areaPath,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success({ content: res.msg, key: 'loading' })
          this.pagination.total = res.total
          this.list = res.list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    createQr(id) {
      create_qr({
        activeId: this.id,
        memberId: id,
      }).then((res) => {
        if (res.code === 1) {
          this.getData()
        } else {
          this.$message.warning({ content: res.msg, key: 'create_qr' })
        }
      })
    },
    batchQrCode() {
      create_qr({ activeId: this.id }).then((res) => {
        if (res.code === 1) {
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    batchExportQr() {
      console.log(this.searchForm.areaPath)
      auto_get_member({
        activeId: this.id,
        areaPath: this.searchForm.areaPath,
        is_all: 'all',
      }).then((res) => {
        if (res.code === 1) {
          this.exportData()
        }
      })
    },
    // 导出数据
    exportData() {
      const headerDisplay = {
        username: '工号',
        nickname: '昵称',
        area_name: '地区',
        qrcode: '二维码',
      }
      const fields = ['username', 'nickname', 'area_name', 'qrcode']
      const n_list = JSON.stringify(this.list, fields)
      const _list = JSON.parse(n_list)
      const list = [headerDisplay, ..._list]

      const ws = XLSX.utils.json_to_sheet(list, {
        header: fields,
        skipHeader: true,
      })

      let workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, ws, 'data drip')

      XLSX.writeFile(workbook, 'auto_program_account.xlsx', {
        type: 'base64',
        bookType: 'xlsx',
      })
    },
    search() {
      this.pagination.total = 0
      this.pagination.current = 1
      this.getData()
    },
  },
}
</script>

<style scoped></style>
